<template>
    <div>
      <div><span style="padding-right: 10px;">Use temporary filter</span><el-switch v-model="selected_use_saved"></el-switch><span style="padding-left: 10px;">Use saved filter</span>
          <el-select filterable width="30%" v-show="selected_use_saved && all_saved_filters" v-model="selected_asset_filter_id">
                <el-option
                        v-for="saved_filter in all_saved_filters"
                        :key="saved_filter.id"
                        :label="saved_filter.name"
                        :value="saved_filter.id">
                  <span>{{saved_filter.name}}</span>
                  <span style="margin-left:20px;float:right;margin-top:0px;">
                    <el-tag
                        v-for="where_used in saved_filter.where_used"
                        type="info" size="mini"
                    >{{ where_used }}</el-tag>
                  </span>
                </el-option>
            </el-select>
        </div>
        <div style="margin-top: 20px;">
            {{naming_text}} <el-switch v-model="selected_show_name"></el-switch>
            <span v-if="selected_show_name">
                <el-input style="margin-top:10px;" v-model="asset_filter.name"></el-input>
            </span>
            <div style="margin-top:20px;">
                {{condition_text}}
                <div style="margin-top: 5px;" v-for="(test, index) in tests">
                    <span v-if="has_multiple">{{index+1}}</span>
                    <el-select filterable width="25%" style="padding-left:10px;" v-model="test.field" placeholder="Select">
                        <el-option
                                v-for="field in fields"
                                :key="field.id"
                                :label="field.display_name"
                                :value="field.display_name">
                        </el-option>
                    </el-select>
                    <el-select filterable width="10%" style="padding-left:10px;" v-model="test.operation" placeholder="Select">
                        <el-option
                                v-for="operator in operators"
                                :key="operator.short"
                                :label="operator.long"
                                :value="operator.short">
                        </el-option>
                    </el-select>
                    <div style="width:25%;display:inline-block;">
                        <el-input v-model="test.value">
                        </el-input>
                    </div>
                    <el-select style="width:70px;" v-model="test.value_type" >
                      <el-option
                          v-for="type in possible_types"
                          :key="type.key"
                          :label="type.value"
                          :value="type.key"
                      ></el-option>
                    </el-select>
                    <el-button type="link" @click="delete_test(test.id)" icon="el-icon-delete"></el-button>

                </div>
                <el-button class="btn-sm" style="margin-left: 10px; margin-top: 10px;" icon="el-icon-plus" @click="add_blank_test"></el-button>
            </div>
        </div>
        <div style="margin-top: 20px;">
            <el-button @click="save">{{save_text}}</el-button>
            <el-button @click="no_filter">Remove filter from chart</el-button>
        </div>

    </div>
</template>

<script>
    export default {
        name: "AssetFilterEdit",
        props: ['asset_filter_id','extent_id','use_saved','show_name'],
        mounted() {
          this.loadExtent()
        },
        watch: {
            selected_use_saved: function (newValue, oldValue) {
              if (!newValue) {
                this.selected_asset_filter_id = this.transient_asset_filter_id
              } else {
                this.selected_asset_filter_id = this.last_used_saved_filter_id
              }
            },
            asset_filter_id: function (newValue, oldValue) {
              this.selected_asset_filter_id = newValue
              if (this.asset_filter_id) {
                this.setNewAssetFilter()
              } else {
                console.log('in asset_filter_id watcher, NOT going to set new asset filter since asset_filter_id is null')
              }
            },
            extent_id: function (newValue, oldValue) {
                this.loadExtent()
            },
            selected_asset_filter_id: function(newValue, oldValue) {
                this.load_data()
            },
            show_name: function(newValue) {
                this.selected_show_name = newValue
            },
            asset_filter: function(newValue) {
                this.using_saved_unmodified = false
            },
            tests: function(newValue) {
                this.using_saved_unmodified = false
            }
        },
        computed: {
            save_text: function() {
              if (this.using_saved_unmodified) {
                  return "Use now"
              }  else {
                  return "Save and use"
              }
            },
          condition_text: function() {
              if (this.tests) {
                let length = this.tests.length
                if (length === 0) {
                  return "You need to add a condition"
                } else if (length === 1) {
                  return "Condition:"
                } else {
                  return "Conditions:"
                }
              } else {
                return ""
              }
          },
            has_multiple: function() {
                if (this.tests) {
                  let length = this.tests.length
                  return length > 1;
                } else {
                  return false;
                }
            },
            naming_text: function() {
              if (this.asset_filter) {
                if (this.asset_filter.name.charAt(0) == "(") {
                  return "Name this filter"
                } else {
                  return "Rename this filter"
                }
              } else {
                return ""
              }
            }
        },
        methods: {
            setNewAssetFilter() {
              if (this.asset_filter_id) {
                this.selected_asset_filter_id = this.asset_filter_id
                let matched = this.all_saved_filters.find((filter) => {
                  return filter.id === this.selected_asset_filter_id
                })
                if (matched) {
                  this.selected_use_saved = true
                } else {
                  this.selected_use_saved = false
                }
              } else {
                this.selected_asset_filter_id = this.transient_asset_filter_id
                this.select_use_saved = false
              }
            },
            loadExtent() {
              axios.get('/api/filters/all/' + this.extent_id)
                  .then(response => {
                    this.all_saved_filters = response.data
                    if (this.asset_filter_id) {
                      this.last_used_saved_filter_id = this.asset_filter_id
                    } else if (this.all_saved_filters && this.all_saved_filters.length !== 0) {
                      this.last_used_saved_filter_id = this.all_saved_filters[0].id
                    }
                    axios.post('/api/filters/add_blank/' + this.extent_id, {
                    }).then(response => {
                      this.transient_asset_filter_id = response.data.id
                      this.load_data()
                      this.setNewAssetFilter()
                    }).catch(error => {
                      console.log('oops getting new filter')
                      console.log(error.error)
                    })
                  })
                  .catch(error => {
                    console.log('oops asset filter pulldowns')
                  })
              axios.get('/api/filters/pulldowns/' + this.extent_id)
                  .then(response => {
                    this.operators = response.data.operators
                    this.fields = response.data.fields
                  })
                  .catch(error => {
                    console.log('oops asset filter pulldowns')
                  })
            },
            resetOnClose() {
              this.selected_asset_filter_id = this.transient_asset_filter_id
            },
            delete_test(test_id) {
                axios.delete('/api/filter_tests/' + this.extent_id + '/' + test_id, {
                }).then(response => {
                    this.load_data()
                }).catch(error => {
                    console.log('oops deleting condition')
                    console.log(error)
                })
            },
            add_blank_test() {
                axios.post('/api/filter_tests/add/' + this.extent_id + '/' + this.selected_asset_filter_id, {
                }).then(response => {
                    this.load_data()
                }).catch(error => {
                    console.log('oops adding test')
                    console.log(error)
                })
            },
            load_data() {
                if (this.selected_asset_filter_id) {
                  axios.get('/api/filters/' + this.selected_asset_filter_id)
                      .then(response => {
                        this.asset_filter = response.data
                        this.tests = this.asset_filter.asset_filter_tests
                        if (this.selected_asset_filter_id) {
                          this.using_saved_unmodified = true
                        }
                        this.$emit('filterLoaded', this.asset_filter)
                      })
                      .catch(error => {
                        console.log('oops asset filter')
                      })
                } else {
                  console.log('NOT loading the filter since we have an id of null')
                }
            },
            no_filter() {
              this.selected_use_saved = false
              this.$emit('filterReset')
            },
            save() {
                axios.patch('/api/filters/' + this.selected_asset_filter_id, {
                    values: this.asset_filter,
                }).then(response => {
                    this.$emit('filterSaved',response.data)
                }).catch(error => {
                    console.log('error on saving asset filter')
                    console.log(error.response)
                })
            },
        },

        data() {
            return {
                transient_asset_filter_id: null,
                last_used_saved_filter_id: null,

                selected_asset_filter_id: null,  // if the prop is passed, this is initially the passed value -- but at any rate it always represents the id of the asset_filter that is currently being edited
                selected_use_saved: false,
                selected_show_name: false,

                using_saved_unmodified: false,

                // These are "live" values of the asset filter as it is being edited, based on the user inputs/selections.
                // These initially load with an existing asset filter's values, if the asset_filter_id prop is passed.
                // These are also loaded with an existing asset filter's values if the user selects an existing, saved asset filter from within this component.
                asset_filter: null, // the root level data for the asset_filter (like name, but not the tests)
                tests: null,        // the lists of actual tests

                // These are relatively static values based on the extent_id (but they do change when the extent changes from the parent component)
                fields: [],         // these are the fields that will appear in the field selection pulldown
                operators: [],      // these are the fields that will appear in the operator selection pulldown
                all_saved_filters: [],
                possible_types: [
                  {key: 'text', value: 'Az'},
                  {key: 'date', value: '📅'},
                  {key: 'number', value:'09'}
                ],
            }
        },
    }
</script>

<style scoped>

</style>